import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PrivateOfferImage from 'assets/images/PrivateOfferImage.png';
import {
  POST_BUYER_BANNER_CLOSE,
  POST_BUYER_PRIVATEOFFER_VIEW,
} from 'constant/app.config';
import { postApiCall } from 'api/apiService';
import { useHistory } from 'react-router-dom';
import ManageOffer from 'component/BuyerRegistration/ManageOffer';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const ViewEyeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_38210_159778)">
        <path
          d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
          stroke="#4898F8"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 12C19.333 16.667 16 19 12 19C8 19 4.667 16.667 2 12C4.667 7.333 8 5 12 5C16 5 19.333 7.333 22 12Z"
          stroke="#4898F8"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_38210_159778">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const PrivateOfferBanner = (props) => {
  const {
    isBuyerDashboard,
    buyerDashboardDetails,
    getBuyerIndividualValue,
    groupIt,
    DashboardGroupCall,
    setManageOffer,
    setPrivateOfferClose,
  } = props;
  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const PropertyId = isBuyerDashboard
    ? buyerDashboardDetails?.property?.propertyId
    : getBuyerIndividualValue?.PropertyDetails?.property?.propertyId;

  const onPropertyClick = (propertyId) => {
    history.push({
      pathname: `market/${propertyId}`,
      state: {
        propertyIds: true,
        dashboardPrivateOfferView: true,
      },
    });
  };

  const manageOfferClick = () => {
    setManageOffer(true);
  };

  const isForSale = isBuyerDashboard
    ? buyerDashboardDetails?.generalCampaignDetails?.generalCampaign ===
      'For Sale'
    : getBuyerIndividualValue?.PropertyDetails?.generalCampaignDetails
        ?.generalCampaign === 'For Sale';

  const [closeLoader, setCloseLoader] = useState(false);
  const handleBuyerPrivateOfferCloseApiCall = async () => {
    const propertyId = isBuyerDashboard
      ? buyerDashboardDetails?.property?.propertyId
      : getBuyerIndividualValue?.PropertyDetails?.property?.propertyId;

    let input = {
      propertyId: propertyId,
      bannerCode: 'BUYER001',
      bannerHeading: 'Buyer Private Offer trigger',
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_BUYER_BANNER_CLOSE, input);

      if (response?.data?.status == 1) {
        setPrivateOfferClose((prev) =>
          prev.includes(propertyId) ? prev : [...prev, propertyId]
        );
        if (!isBuyerDashboard) {
          groupIt();
        }
        if (isBuyerDashboard) {
          DashboardGroupCall();
        }
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  const [viewLoader, setViewLoader] = useState(false);
  const handleBuyerPrivateOfferViewApiCall = async () => {
    let input = {
      propertyId: PropertyId,
      agentId:
        getBuyerIndividualValue?.PropertyDetails?.agentDetails?.agentDetails,
    };

    try {
      setViewLoader(true);

      const response = await postApiCall(POST_BUYER_PRIVATEOFFER_VIEW, input);

      if (response?.data?.status == 1) {
        if (!isBuyerDashboard) {
          setManageOffer(true);
          groupIt();
        }
        if (isBuyerDashboard) {
          DashboardGroupCall();
        }
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setViewLoader(false);
      if (!isBuyerDashboard) {
        setManageOffer(true);
      }
    }
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 0 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={9} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 1 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textDecoration: 'none',
                    marginTop: '-10px',
                  }}
                >
                  {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName ||
                    buyerDashboardDetails?.propertyAddress?.streetName}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '20px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                  }}
                >
                  Private Offer Received - Review Now!
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: !matchessm && 1.5,
                    color: '#FFF',
                  }}
                >
                  {isForSale
                    ? `The vendor has extended a Private Offer to selected buyers.
                  Position yourself as the premium buyer before this opportunity
                  is withdrawn! In most cases the premium buyer has the best
                  chance to secure the property before Auction and end the
                  campaign early. Don't miss out – act first.`
                    : `The vendor has extended a Private Offer to selected buyers.
                Position yourself as the premium buyer before this opportunity
                is withdrawn! In most cases the premium buyer has the best
                chance to secure the property before the campaign ends. Don't
                miss out – act first.`}
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  mt={2.5}
                  alignItems="center"
                  flexWrap="wrap"
                  justifyContent={matchessm && 'space-between'}
                >
                  <Button
                    disabled={closeLoader}
                    onClick={handleBuyerPrivateOfferCloseApiCall}
                    endIcon={closeLoader && <CircularProgress size="20px" />}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: 'transparent',
                      color: '#E6F2FF',
                      fontFamily: 'poppins',
                      fontWeight: 300,
                      '&:hover': {
                        bgcolor: 'rgb(33, 132, 253)',
                        color: '#E6F2FF',
                      },
                    }}
                  >
                    Ignore
                  </Button>

                  <Box display="flex" alignItems="center">
                    <Button
                      onClick={() => {
                        if (isBuyerDashboard) {
                          onPropertyClick(PropertyId);
                        } else {
                          setManageOffer(true);
                        }
                      }}
                      disabled={viewLoader}
                      startIcon={<ViewEyeIcon />}
                      sx={{
                        px: 4,
                        height: matchessm ? 35 : 42,
                        borderRadius: '5px',
                        fontSize: matchessm ? '12px' : '14px',
                        textTransform: 'none',
                        border: '1px solid #E6F2FF',
                        backgroundColor: '#FFF',
                        color: '#2184FD',
                        fontWeight: 400,
                        fontFamily: 'poppins',
                        '&:hover': {
                          bgcolor: '#FFF',
                          color: '#2184FD',
                        },
                      }}
                    >
                      View
                    </Button>

                    {viewLoader && (
                      <CircularProgress
                        size={30}
                        sx={{ color: 'white', ml: 2 }}
                      />
                    )}
                  </Box>
                </Stack>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              display={matchessm ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={PrivateOfferImage}
                alt="Private Offer Image"
                style={{ objectFit: 'contain', height: '265px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export default PrivateOfferBanner;
